<template>
  <LazyBlogPageLayout hydrate-on-idle path="delivery-and-payment" />
</template>
